export default "__VITE_ASSET__lUrRy5FFg4ugUpMBt$Ob5Q__"